import truncate from 'lodash/truncate';
import isPlainObject from 'lodash/isPlainObject';
import { cloneObject } from '../../components/utils/browser';
// List of boolean keys from PapiDeviation
const bools = [
    'isJournal',
    'isVideo',
    'isGif',
    'isPurchasable',
    'isAdoptable',
    'isFavouritable',
    'isTextEditable',
    'isBackgroundEditable',
    'isShareable',
    'isCommentable',
    'isFavourited',
    'isDeleted',
    'isMature',
    'isNsfg',
    'isAllowedForSafeAccess',
    'isDownloadable',
    'isAntisocial',
    'isBlocked',
    'isPublished',
    'isScheduled',
    'isPinned',
    'isDailyDeviation',
    'hasPrivateComments',
    'hasCommentedOn',
    'hasNft',
    'isDreamsofart',
    'isAiUseDisallowed',
    'isAiGenerated',
    'canUpdateAiClaim',
    'hyped',
    'hasNewContent'
];
// The optional fields we can safely drop
const drop = [
    'extended',
    'stats',
    'isTextEditable',
    'legacyTextEditUrl',
    'dailyDeviation',
    'motionBook',
    'print',
    'pcp',
    'blockReason',
    'blockReasons',
    'groupDestination',
    'background'
];
// Nested deviations
const nested = [
    'coverImage',
    'primaryTier'
];
export function toLightweightDeviation(deviation) {
    const lightweight = {};
    const keys = Object.keys(deviation);
    for (const key of keys){
        // Text content, chop down excerpt and remove fulltext
        if (key === 'textContent' && deviation['textContent']) {
            var _deviation_key, _deviation_key1, _deviation_key_html, _deviation_key2;
            var _deviation_key_html_type, _deviation_key_html_features;
            lightweight[key] = {
                excerpt: truncate((_deviation_key = deviation[key]) === null || _deviation_key === void 0 ? void 0 : _deviation_key.excerpt, {
                    length: 50,
                    separator: /,? +/,
                    omission: ''
                }),
                html: {
                    type: (_deviation_key_html_type = (_deviation_key1 = deviation[key]) === null || _deviation_key1 === void 0 ? void 0 : _deviation_key1.html.type) !== null && _deviation_key_html_type !== void 0 ? _deviation_key_html_type : 'tiptap',
                    features: (_deviation_key_html_features = (_deviation_key2 = deviation[key]) === null || _deviation_key2 === void 0 ? void 0 : (_deviation_key_html = _deviation_key2.html) === null || _deviation_key_html === void 0 ? void 0 : _deviation_key_html.features) !== null && _deviation_key_html_features !== void 0 ? _deviation_key_html_features : ''
                }
            };
            continue;
        }
        // Drop keys we dont need
        if (drop.includes(key)) {
            continue;
        }
        // Nested PapiDeviations
        if (nested.includes(key) && deviation[key]) {
            lightweight[key] = toLightweightDeviation(deviation[key]);
            continue;
        }
        // Copy plain objects
        if (isPlainObject(deviation[key])) {
            lightweight[key] = cloneObject(deviation[key]);
            continue;
        }
        // boolean optim, drop any falsey values
        if (bools.includes(key) && deviation[key] === false) {
            continue;
        }
        // scalar copy it over
        lightweight[key] = deviation[key];
    }
    return lightweight;
}

//# sourceMappingURL=toLightweightDeviation.js.map